import axios from "axios"
const BASE_URL = "https://youtube-v31.p.rapidapi.com"



const options = {
 
  
  params: {
    
    maxResults: '50'
  },
  headers: {
    'X-RapidAPI-Key': 'ce287ce869msh2f8c4345c16f5cap1adc71jsn72dcb98b24ef',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
  }
};

export const fetchFromAPI = async (url)=>{
    const {data} = await axios.get(`${BASE_URL}/${url}`,options);
    return data;
}